import {Button, ButtonProps, StyleProps} from '@chakra-ui/react';

export const ErrorButton: React.FC<
  ButtonProps &
    StyleProps & {
      libelle: string;
      refreshing?: boolean;
      onClick: () => void;
      primaryColor?: string;
    }
> = ({libelle, refreshing, onClick, primaryColor, ...props}) => (
  <Button
    variant='ghost'
    border='1px'
    borderColor={primaryColor ?? 'blue.main'}
    color={primaryColor ?? 'blue.main'}
    isDisabled={refreshing}
    onClick={onClick}
    cursor='pointer'
    {...props}
  >
    {libelle}
  </Button>
);
